import { COMPLETED } from 'customer-data-objects/engagement/EngagementStatusTypes';
import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { STATUS } from 'customer-data-objects/task/TaskPropertyNames';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import { START_TASK_QUEUE_SCOPES } from '../../constants/scopes';
import { useSelector } from '../../context/Redux';
import { useStartQueueFromSelected } from '../../hooks/useStartTaskQueue';
import { useTasks } from '../../hooks/useTasks';
import { createHasOneOfScopesSelector } from '../../redux/selectors/auth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const hasStartQueueScopeSelector = createHasOneOfScopesSelector(START_TASK_QUEUE_SCOPES);
export default function BulkStartSelectedTasks({
  viewId,
  allSelected,
  selection
}) {
  const tasks = useTasks(selection);
  const onlyIncompleteTaskIds = useMemo(() => tasks.filter(task => getProperty(task, STATUS) !== COMPLETED && task.objectId).map(task => task.objectId), [tasks]);
  const hasStartQueueScope = useSelector(hasStartQueueScopeSelector);
  const startSelectedTasks = useStartQueueFromSelected({
    taskIds: onlyIncompleteTaskIds,
    viewId: String(viewId)
  });
  const tooltip = allSelected ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "tasks-table.bulkActions.startSelectedTasks.allSelected"
  }) : onlyIncompleteTaskIds.length === 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "tasks-table.bulkActions.startSelectedTasks.noIncompleteTasks"
  }) : null;
  return hasStartQueueScope ? /*#__PURE__*/_jsx(UIButton, {
    use: "link",
    onClick: startSelectedTasks,
    disabled: Boolean(tooltip),
    "data-test-id": "bulk-start-tasks",
    children: /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "playerPlay"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "tasks-table.bulkActions.startSelectedTasks.label",
        options: {
          count: onlyIncompleteTaskIds.length
        }
      }), tooltip && /*#__PURE__*/_jsx(UIHelpIcon, {
        title: tooltip
      })]
    })
  }) : null;
}